module.exports = __webpack_public_path__ + "Flag-466.777692cb8e7e3ba129cda06d6b37c9e8.svg";